"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = MyPay;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const react_native_1 = require("react-native");
const Helper_1 = require("../Helper");
const Screen_1 = __importDefault(require("../components/Screen"));
const Theme_1 = require("../Theme");
const MasonryList_1 = __importDefault(require("../components/MasonryList"));
const PayStubsCard_1 = __importDefault(require("../partials/PayStubsCard"));
const RetirementSummaryCard_1 = __importDefault(require("../partials/RetirementSummaryCard"));
const TaxesSummaryCard_1 = __importDefault(require("../partials/TaxesSummaryCard"));
const DirectDepositCard_1 = __importDefault(require("../partials/DirectDepositCard"));
const HolidaySavingsCard_1 = __importDefault(require("../partials/HolidaySavingsCard"));
const UserContext_1 = require("../contexts/UserContext");
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
function MyPay(props) {
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const { size, columns } = (0, ResponsiveContext_1.useResponsiveContext)();
    const [refreshKey, setRefreshKey] = react_1.default.useState(0);
    const { t } = (0, react_i18next_1.useTranslation)();
    const limitedView = userContext.isFormer || userContext.isContractor;
    // Randomly update the key used in the MasonryList below. This will force the list to re-render
    const onRefresh = react_1.default.useCallback(() => {
        setRefreshKey(Math.random());
    }, []);
    react_1.default.useEffect(() => {
        // Request a review from the user when MyPay screen begins to load (on Mobile)
        if (!Helper_1.Helper.isPlatformWeb) {
            Helper_1.Helper.handleReviewPrompt();
        }
    }, []);
    return ((0, jsx_runtime_1.jsxs)(Screen_1.default, { onRefresh: onRefresh, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: columns == 1 ? {} : { marginVertical: 6, marginHorizontal: 16 }, children: (0, jsx_runtime_1.jsx)(react_native_1.Image, { resizeMode: 'cover', source: size != 'sm' ? Theme_1.IMAGES.PayBackgroundWeb : Theme_1.IMAGES.PayBackground, style: { width: '100%', height: 'auto', aspectRatio: size != 'sm' ? 11.2 : 5.6, marginTop: size != 'sm' ? 12 : 4, borderRadius: size != 'sm' ? 4 : 0 } }) }), (0, jsx_runtime_1.jsxs)(MasonryList_1.default, { children: [(0, jsx_runtime_1.jsx)(PayStubsCard_1.default, { navigation: props.navigation }), limitedView || (0, jsx_runtime_1.jsx)(HolidaySavingsCard_1.default, { navigation: props.navigation }), limitedView || (0, jsx_runtime_1.jsx)(DirectDepositCard_1.default, { navigation: props.navigation }), limitedView || (0, jsx_runtime_1.jsx)(RetirementSummaryCard_1.default, { headerText: t('common:screenTitles.retirement'), footerActions: true, headerEdit: false, navigation: props.navigation }), userContext.isContractor || (0, jsx_runtime_1.jsx)(TaxesSummaryCard_1.default, { navigation: props.navigation })] }, refreshKey)] }));
}
;
